const lines = ["A burocracia fica no digital.", "O atendimento continua pessoal."];

// Cada palavra acende ao passar pela linha de leitura (motion.js); sem JS, o texto aparece inteiro
export default function Tagline() {
  return (
    <section className="sec tagline" aria-label="Nosso jeito de trabalhar">
      <div className="wrap">
        <p className="tagline-text">
          {lines.map((line) => (
            <span className="tagline-line" key={line}>
              {line.split(" ").map((word, i) => (
                <span className="tw" key={i}>
                  {word}{" "}
                </span>
              ))}
            </span>
          ))}
        </p>
      </div>
    </section>
  );
}
